<template>
  <div
    class="preorder"
    :class="{ active: isActive }"
    @click="closePreOrder($event)"
  >
    <div class="sign-up">
      <h2>Reserve your Upmood Band now!</h2>
      <h3>
        Sign-up today for FREE and take an extra 30% off your Upmood band
        purchase.
      </h3>
      <form class="sign-up-form" @submit.prevent="sendPreOrder">
        <input type="email" placeholder="Email" v-model="email" required />
        <button class="button-cyan" :disabled="sending">
          <span class="loading" v-if="sending"
            ><span class="load open"></span> Sending</span
          >
          <span v-else>Submit</span>
        </button>
      </form>
      <img class="clip-art" src="@/assets/img/breakdown.png" alt="" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["isActive"],

  data() {
    return {
      email: ""
    };
  },

  computed: {
    ...mapGetters({
      sending: "preOrder/getSending",
      response: "preOrder/getResponse"
    })
  },

  watch: {
    $route() {
      this.email = "";
    }
  },

  methods: {
    togglePreOrder() {
      this.$store.dispatch("preOrder/togglePreOrder", false);
    },

    closePreOrder(e) {
      if (e.target.className.includes("preorder")) this.togglePreOrder();
    },

    async sendPreOrder() {
      this.$store.commit("preOrder/TOGGLE_SENDING", true);
      let isEmailVerified = await this.$options.filters.verifyEmail(this.email);

      if (!isEmailVerified) {
        this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: "Email not valid!",
          button: "Close",
          hasError: true
        });

        this.$store.dispatch("alert/toggleAlert", true);

        this.$store.commit("preOrder/TOGGLE_SENDING", false);
        return;
      }

      let formData = new FormData();

      formData.append("email", this.email);

      await this.$store.dispatch("preOrder/sendPreOrder", formData);
      if (this.response.data) {
        if (this.response.data.status == 200) {
          this.$store.dispatch("alert/setContent", {
            title: "Congratulations!",
            message: "You have successfully reserved an Upmood Band.",
            button: "Done",
            hasError: false
          });
          this.email = "";
        } else if (this.response.data.status == 422) {
          this.$store.dispatch("alert/setContent", {
            title: "Sorry",
            message: this.response.data.errors.email[0],
            button: "Close",
            hasError: true
          });
        } else {
          this.$store.dispatch("alert/setContent", {
            title: "Sorry",
            message: "Something went wrong!",
            button: "Close",
            hasError: true
          });
        }
      } else {
        this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: "Something went wrong!",
          button: "Close",
          hasError: true
        });
      }

      this.$store.dispatch("alert/toggleAlert", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.preorder {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  display: none;
  z-index: +2;

  @include mobile {
    padding: 10px;
  }

  &.active {
    display: flex;
  }

  .sign-up {
    height: 262px;
    width: 668px;
    border-radius: 3px;
    background-color: #ffffff;
    text-align: center;
    padding: 25px;
    position: relative;

    @include mobile {
      width: 100%;
    }

    h2 {
      color: #f24f63;
      font-size: 24px;
      font-weight: bold;
      font-family: $Quicksand;

      @include mobile {
        font-size: 16px;
        font-weight: normal;
      }
    }

    h3 {
      color: $color2;
      font-size: 16px;
      line-height: 22px;
      padding: 15px 0;
      font-family: $Lato;

      @include mobile {
        font-size: 12px;
        line-height: 14px;
        margin: 2px 0;
      }
    }

    .sign-up-form {
      width: 485px;
      padding: 30px 10px;
      position: relative;

      @include mobile {
        padding: 10px;
        width: 100%;
      }

      input {
        width: 100%;
        font-size: 18px;
        display: block;
        border: none;
        outline: none;
        border-bottom: 1px solid $color9;
        padding: 5px 0;
        color: $color2;
        font-family: $Lato;

        &:required {
          box-shadow: none !important;
        }
        &:invalid {
          box-shadow: none !important;
        }

        @include mobile {
          margin-bottom: 10px;
          font-size: 12px;
        }
      }

      button {
        margin: 30px 0;
        position: absolute;
        right: 0;
        padding: 10px 20px;

        @include mobile {
          position: relative;
          margin: 0 auto;
        }
      }
    }

    .clip-art {
      width: 140px;
      height: 150px;
      position: absolute;
      bottom: 0;
      right: 0;

      @include mobile {
        width: 80px;
        height: 80px;
        right: 10px;
      }
    }
  }
}
</style>
